import React from "react";
import styled from "styled-components";
import {
  Link,
  Element,
  Events,
  animateScroll as scroll,
  scrollSpy,
  scroller,
} from "react-scroll";
//
import Item from "./link";
//

export default ({ items, links, title, ...rest }) => (
  <Wrap>
    <Top>
      <Title>{title}</Title>
      <Menu>
        {items.map((item, i) => (
          <MenuItem key={item.id}>
            <Link
              key={item.id}
              activeClass="active"
              to={item.id}
              spy={true}
              smooth={true}
              // hashSpy={true}
              offset={-170}
            >
              {item.item_title}
            </Link>
          </MenuItem>
        ))}
      </Menu>
    </Top>
    <List>
      {links.map((link, i) => (
        <Item key={i} {...link} />
      ))}
    </List>
  </Wrap>
);
//
const Wrap = styled.div`
  position: -webkit-sticky;
  position: sticky;
  // top: 3rem;
  // top: calc(3rem + 2px);
  top: 0;
  // z-index: 110;

  a {
    color: #007e52;
    display: inline-block;
    padding: 0.1rem 0.5rem;
    :hover,
    &.active {
      color: #6f422c;
    }
  }

  @media (min-width: 769px) {
    a {
      font-size: 1.2em;
      padding: 0 0.8rem;
    }
  }
`;
const Top = styled.div`
  background-color: #ffff;
  border-bottom: 1px solid #d9dce4;

  @media (min-width: 769px) {
    margin: 0 1rem;
    padding: 0.5rem 3.2rem;
  }
`;
const Menu = styled.nav`
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  height: 100%;
  margin: 0.25rem 0;

  @media (min-width: 769px) {
    justify-content: flex-start;
    margin: 0;
  }
`;
const MenuItem = styled.div`
  cursor: pointer;
  color: #213e65;
  display: flex;
  margin: 0.25rem 0;

  @media (min-width: 769px) {
    padding: 0.5rem 0;
  }
`;
const Title = styled.h2`
  min-height: 3rem;
  min-height: calc(3rem + 2px);
  margin: 0 auto;
  text-align: center;
  line-height: 3rem;
  line-height: calc(3rem + 2px);
  white-space: nowrap;

  &:after {
    background-color: currentColor;
    content: "";
    display: block;
    height: 3px;
    margin: 0 auto;
    width: 3rem;
  }

  @media (min-width: 769px) {
    padding: 0 0.8rem;
    text-align: left;

    &:after {
      margin: 0.5rem 0;
    }
  }
`;
const List = styled.ul`
  align-items: flex-start;
  background-color: #007e52;
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  justify-content: center;
  margin: 0;
  padding: 0;
  width: 100%;

  a {
    color: #ffff;
    font-weight: 400;
    padding: 0;
  }

  @media (min-width: 769px) {
    background-color: #ffff;
    flex-direction: column;
    justify-content: flex-start;
    position: absolute;
    right: 1rem;
    width: 220px;

    a {
      color: #007e52;
      margin: 0;
    }
  }
`;
